/*
    16322: PREMIUM
    16323: REGULAR
*/

import axios from "axios";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import CannabisShowCaseGrid from "./CannabisShowCaseGrid";
import CannabisShowCaseModal from "./CannabisShowCaseModal";
import CannabisShowCaseLoading from "./CannabisShowCaseLoading";
import CannabisShowCaseError from "./CannabisShowCaseError";
import CannabisShowCaseTitle from "./CannabisShowCaseTitle";
import { Analytics, CannabisShowcaseAnalytics } from "./Analytics";

Modal.setAppElement("body");

const CannabisShowCase = ({ restUrl }) => {
    // const URL = `/api/solr?filters={"featured_type":"(16268 OR 16274 OR 16275 OR 16276 OR 16277 OR 16278) OR featured_type_varchar:(16268 OR 16274 OR 16275 OR 16276 OR 16277 OR 16278)"}`;
    const URL = `/api/solr?filters={"featured_type": "(16322 OR 16323) OR featured_type_varchar:(16322 OR 16323)"}&sort=updated_at desc`;
    const [showCaseState, setShowCaseState] = useState({
        loading: true,
        items: null,
        error: false,
        showModal: false,
        currentItem: null
    });
    const { items, showModal, error, currentItem, loading } = showCaseState;

    const handleOpenModal = sku => {
        let currentModalItem = null;

        if (sku !== null) {
            currentModalItem = items.filter(i => i.sku === sku);
        }
        setShowCaseState({
            ...showCaseState,
            showModal: true,
            currentItem: currentModalItem
        });

        // Push click event to Google Tag Manager
        Analytics.click(CannabisShowcaseAnalytics.makeMosaicEventProperties(currentModalItem[0]));
    };

    const handleCloseModal = () => {
        setShowCaseState({
            ...showCaseState,
            showModal: false,
            currentItem: null
        });
    };

    // turn random shuffle SCRIPT | https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
    const shuffle = (a) => {
        for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));

            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    };

    useEffect(() => {
        axios
            .get(URL)
            .then(data => {
                setShowCaseState({
                    ...showCaseState,
                    //items: data.data.response.result,  // turn random shuffle OFF
                    items: shuffle(data.data.response.result), // turn random shuffle ON
                    error: false,
                    loading: false
                });
            })
            .catch(err => {
                setShowCaseState({
                    ...showCaseState,
                    error: true,
                    loading: false
                });
                console.error(err);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (loading) return <CannabisShowCaseLoading loading={loading} />;
    if (error || items === null) return <CannabisShowCaseError />;
    return (
        <div className="cms cms--cannabisshowcase">
            <div className="container">
                <CannabisShowCaseTitle title="Cannabis Showcase" />
                <div className="cannabisdirectory">
                    <CannabisShowCaseGrid
                        data={items}
                        restUrl={restUrl}
                        handleOpenModal={handleOpenModal}
                    />
                    <Modal
                        closeTimeoutMS={700}
                        isOpen={showModal}
                        contentLabel="LabX.com Cannabis Showcase"
                        className="cannabisshowcase-modal"
                        overlayClassName="showcase-overlay"
                    >
                        <div
                            onClick={handleCloseModal}
                            className="cannabisshowcase-close"
                        >
                            <i className="fas fa-times" aria-hidden="true"></i>
                            <span className="sr-only">Close Cannabis Showcase Modal</span>
                        </div>
                        <CannabisShowCaseModal item={currentItem} restUrl={restUrl} />
                    </Modal>
                </div>
            </div>
        </div>
    );
};

CannabisShowCase.defaultProps = {
    restUrl: ""
};

CannabisShowCase.propTypes = {
    restUrl: PropTypes.string.isRequired
};

export default CannabisShowCase;
